<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KsFTuC/tc-custom/9781504061834.jpg?1725275644789" alt="This image is the cover for the book Red Eve"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Red Eve
      </h1>
      <p class="bookDescription body article font2">
        <b>A suspenseful love story set in medieval Europe from the author of the long-running Allan Quatermain series.</b><br/>  <br/> First serialized in the early 1900s, this historical romance tells the story of the beautiful Eve Clavering, known as “Red Eve” for her many scarlet dresses.<br/>  <br/> Betrothed to the knight Sir Edmund Acour, Eve learns he may be a traitor to the Crown. However, her suspicions are quashed by a love potion administered to her by Acour, and the two are wed. Only Eve’s longtime lover, merchant’s son Hugh de Cressi, can save her from a bleak fate in this gripping novel set during the tumultuous reign of King Edward III.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        H. Rider Haggard
      </h2>
      
      <p class="authorDescription body article">H. Rider Haggard (1856&ndash;1925) was an English adventure novelist. Haggard studied law, but rather than pursuing a legal career took a secretarial position in what is now South Africa. His time there provided the inspiration for some of his most popular novels, including <I>She</I> (1887), an early classic of the lost world fantasy genre and one of the bestselling books of all time.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?063eb782